import {createContext} from "react";

import {Service} from "@/lib/types/checks.ts";

export const ChecksContext = createContext<Record<number, Service>>({});
